import { Skeleton } from "antd"
import React, {
  type ComponentProps,
  type ComponentType,
  Suspense,
  lazy
} from "react"

import { isChunkLoadError } from "../../../utils/handlers/is-chunk-load-error.ts"
import { reloadForChunkError } from "../../../utils/handlers/reload-for-chunk-error.ts"

// A screen's code is fetched the first time it is opened, not with the app.
// After a deploy, an open tab asks for files the release replaced; the route's
// error page would show a crash, so a stale file reloads the app instead, the
// way the global handlers in app.tsx do for every other import.
export function lazyPage<T extends ComponentType<any>>(
  load: () => Promise<{ default: T }>
): ComponentType<ComponentProps<T>> {
  const Page = lazy(() =>
    load().catch((error: unknown) => {
      if (!isChunkLoadError(error)) throw error
      reloadForChunkError()
      return new Promise<{ default: T }>(() => {})
    })
  )

  function LazyPage(props: ComponentProps<T>) {
    return (
      <Suspense fallback={<Skeleton active style={{ padding: 24 }} />}>
        <Page {...props} />
      </Suspense>
    )
  }

  return LazyPage
}
